import { TimetableRelationshipProperties } from '@bp/planung-graphql-types';
import { toJS } from 'mobx';
import { observer } from 'mobx-react-lite';
import { useMemorizedCacheTag } from '../../../hooks/useMemorizedCacheTag';
import { useTeacherAvailabilityMatrixQuery } from '../../../types/planung-graphql-client-defs';
import { AvailabilityMatrix, Day, TimeGridEntry } from '../../AvailabilityMatrix/AvailabilityMatrix';
import { useTimetableStore } from '../../TimetableGrid/TimetableProvider';
import { TimetableVersionTableType } from '../graphql/types';

type TimetableVersionTeachersMatrixProps = {
  selected: TimetableVersionTableType | null;
  versionUuid?: string | null;
  timeGridEntries: TimeGridEntry[];
  loading: boolean;
  onChange: (availability: TimetableRelationshipProperties) => void;
};

export const TimetableVersionTeachersMatrix = observer(
  ({ selected, versionUuid, timeGridEntries, loading, onChange }: TimetableVersionTeachersMatrixProps) => {
    const context = useMemorizedCacheTag('TEACHER_MATRIX');

    const [{ data, fetching }, execute] = useTeacherAvailabilityMatrixQuery({
      variables: {
        versionUuid: versionUuid ?? '',
      },
      context: context,
    });

    const days: Day[] = ['mon', 'tue', 'wed', 'thu', 'fri', 'sat', 'sun'];

    const hours = timeGridEntries.filter((entry) => !entry.pause);

    const availability = data?.timetableVersions[0].teachersConnection.edges.find(
      (e) => e.node.uuid === selected?.uuid,
    );

    const store = useTimetableStore();

    return (
      <AvailabilityMatrix
        days={days}
        hours={hours}
        availability={availability?.properties}
        readonly={toJS(store.readonly) || fetching}
        loading={loading}
        onChange={(items) => {
          onChange(items);
          execute();
        }}
      />
    );
  },
);
